import c from "./SearchAndChoose.module.scss";
import {useEffect, useState} from "react";
import Helpers from "../../helpers/Helpers";
import ExhibitorCard from "./ExhibitorCard";
import {CrossButton} from "../../components/ui/CrossButton";

export default function SearchAndChoose({setIsOpen, chooseFunction, searchIn, searchBy, searchParams, stringPathToPreview='name'}){
    const [searchString, setSearchString] = useState('');
	const [page, setPage] = useState(0);
	const [results, setResults] = useState([]);
	const [totalPages, setTotalPages] = useState(0);
	const [totalResults, setTotalResults] = useState(0);

	const search = async (searchString) => {
		let res = await Helpers.searchPaginated(searchIn, {
			[searchBy]: {$regex: searchString, $options: 'i'}, ...searchParams}
			, page);
		if(!res)
			return;

		setResults(res.mainObj);
		if (res.pagination?.totalPages > 0) {
			setTotalPages(res.pagination.totalPages);
			setTotalResults(res.pagination.totalResults);
		}
	}
	useEffect(() => {
		search(searchString);
	}, [page]);

	return <div className={c.root}>
		<div className={c.container}>
			{setIsOpen&&<CrossButton onclick={()=>setIsOpen(false)}/>}
			<h4>Velg</h4>
			<form onSubmit={(e) => e.preventDefault()}>
				<input
					autoFocus={true}
					type="text"
					defaultValue={searchString}
					onChange={(ev) => setSearchString(ev.currentTarget.value)}
					onKeyDown={(ev) => {
						if (ev.key === 'Enter') {
							ev.preventDefault(); // Prevent default form submit on "Enter"
							search(searchString); // Trigger the search function
						}
					}}
				/>
				<button type="button" onClick={() => search(searchString)}>Søk</button>
			</form>

			<div className={c.results}>
				{results.map((result, index) => {
					return <button type={"button"} key={index} className={c.resultItem}
							onClick={(ev) => {
						ev.preventDefault();
						chooseFunction && chooseFunction(result._id)
					}}>
						<h3>{Helpers.getByDotNotation(result, stringPathToPreview)}</h3>
					</button>
				})}
			</div>
			{totalPages>1&&<div className={c.pagination}>
				<button disabled={page <= 0} type={'button'} onClick={() => {
					setPage(page - 1)
				}}>{"< Forrige"}
				</button>
				<span>{(page+1)+'/'+totalPages}</span>
				<button disabled={totalPages <= (page + 1)} type={'button'} onClick={() => {
					setPage(page + 1)
				}}>Neste >
				</button>
			</div>}
		</div>
	</div>
}